@use "variables" as *;
@use "common/config/breakpoints";

.grid {
  position: relative;
  width: 100%;
  display: inline-grid;
  column-gap: 0 $spacing-2 $spacing-2;
  grid-template-columns: auto auto auto 2fr;
  align-items: center;

  > div:last-child {
    justify-self: end;
  }

  .batchOpsWrapper {
    padding-right: $spacing-2;
  }

  @media (max-width: (breakpoints.$breakpoint-xl)) {
    column-gap: $spacing-2;
    grid-template-columns: auto auto 2fr;
    column-gap: $spacing-2 $spacing-2;

    > div:last-child {
      justify-self: start;
    }
  }
}
